<template>
  <v-container grid-list-lg fluid class="chat-categories-table-container">
    <vue-perfect-scrollbar>
      <v-flex xs12 class="chat-categories-table-container">
        <data-table
          :filters="filters"
          :limit="10"
          url="/chat_categories"
          content="CategoriesList"
          class="mb-5" @listElementEdit="editCategory"
          :key="`data-table-categories-${datatableUpdate ? 1 : 2}`"
          @deleteItem="assignDelete">
          <template slot="navigation-bar">
            <v-flex md6>
              <v-text-field
                v-model="filters.search"
                label="Buscar..."
                color="black"
                solo>
              </v-text-field>
            </v-flex>
            <v-flex md3>
              <v-select
                v-model="filters.type"
                :items="filterTypes"
                color="grey"
                solo>
              </v-select>
            </v-flex>
            <v-flex md3 class="text-xs-right">
              <v-btn v-if="checkCreate()" block class="k-orange-linear white--text ma-0" large @click="addCategory">
                AGREGAR
              </v-btn>
            </v-flex>
          </template>
        </data-table>
      </v-flex>
    </vue-perfect-scrollbar>
    <chat-category-dialog
      @error="showErrorModal"
      :id="id"
      :edit="edit"
      :form="form"
      :show="dialog"
      :types="types"
      :can-change-type="canChangeType"
      @update="updateList"
      @close="closeCategoryModal">
    </chat-category-dialog>
    <delete-dialog
      @error="showErrorModal"
      :text="deleteItem.text"
      :id="deleteItem.id"
      url="chat_categories"
      :show="deleteItem.show"
      @deleted="datatableUpdate = !datatableUpdate"
      @close="deleteItem.show = $event">
    </delete-dialog>
    <alert-dialog @close="showError = false" :show="showError">
      <v-layout slot="content">
        <v-flex xs12 class="text-xs-center">
          <span v-if="typeof errorText === 'string'">
            {{ errorText }}
          </span>
          <span v-else>
            <span v-for="(err, index) in getErrorMessage(errorText)" :key="`error-${index}`">
              {{ err }}
            </span>
          </span>
        </v-flex>
      </v-layout>
    </alert-dialog>
  </v-container>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
import EventBus from '@/event-bus';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import DataTable from '@/components/global/DataTable';
import AlertDialog from '@/components/global/AlertModal';
import SaveDialog from '@/components/global/SaveDialog';
import DeleteDialog from '@/components/global/DeleteDialogV2';
import saveDialogMixin from '@/mixins/saveDialog';
import ChatCategoriesList from './ChatCategoriesList';
import ChatCategoryDialog from './ChatCategoryDialog';
import permissionsMixin from '@/mixins/permissions';

Vue.component('CategoriesList', ChatCategoriesList);

export default {
  components: {
    DataTable,
    SaveDialog,
    AlertDialog,
    DeleteDialog,
    ChatCategoryDialog,
    VuePerfectScrollbar,
  },
  mixins: [
    saveDialogMixin,
    permissionsMixin,
  ],
  mounted() {
    EventBus.$on('deleted', () => {
      this.updateList();
    });
  },
  destroy() {
    EventBus.$off('deleted');
  },
  data() {
    return {
      showError: false,
      errorText: '',
      filters: {
        search: '',
        type: '',
      },
      types: [
        {
          value: 'payment_promise',
          text: 'Compromiso',
        },
        {
          value: 'next_contact',
          text: 'Próximo contacto',
        },
        {
          value: 'movement',
          text: 'Movimiento',
        },
        {
          value: 'black_list',
          text: 'Lista negra',
        },
        {
          value: 'unsolved',
          text: 'Sin resolver',
        },
      ],
      form: {
        name: '',
        type: '',
      },
      deleteItem: {
        text: '',
        id: 0,
        show: false,
      },
      id: 0,
      datatableUpdate: false,
      canChangeType: false,
    };
  },
  computed: {
    filterTypes() {
      const empty = [
        {
          value: '',
          text: 'Tipo',
        },
      ];

      return _.concat(empty, this.types);
    },
  },
  methods: {
    addCategory() {
      this.edit = false;
      this.dialog = true;
    },
    assignDelete({ name, id }) {
      this.deleteItem.text = name;
      this.deleteItem.id = id;
      this.deleteItem.show = true;
    },
    editCategory($event) {
      // eslint-disable-next-line
      const { id, name, type, can_change_type, days = 0 } = $event;
      // eslint-disable-next-line
      this.canChangeType = type !== 'unsolved';
      this.id = id;
      this.form = {
        name,
        type,
        days,
      };
      this.edit = true;
      this.dialog = true;
    },
    closeCategoryModal() {
      this.id = 0;
      this.dialog = false;
      this.canChangeType = false;
      this.form = {
        name: '',
        type: '',
      };
    },
    showErrorModal(text) {
      this.errorText = text;
      this.showError = true;
    },
    updateList() {
      this.datatableUpdate = !this.datatableUpdate;
      this.closeCategoryModal();
    },
    getErrorMessage(obj) {
      const values = Object.values(obj.errors);
      return _.flatten(values);
    },
    checkCreate(){
      return this.checkPermissions([
        'create_chat_categories',
      ]);
    },
  },
};
</script>
<style scoped>
  .chat-categories-table-container > .container {
    padding-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/chat_center_v2/config/ChatCategories.vue